var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClinicIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "huge-icon/health/outline/medical service"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 3032",
    d: "M14 12.8945V19.8945",
    stroke: "#A461D8",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 3033",
    d: "M17.5 16.3945H10.5",
    stroke: "#A461D8",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.33398 7.0612V5.89453C9.33398 3.96153 10.901 2.39453 12.834 2.39453H15.1673C17.1003 2.39453 18.6673 3.96153 18.6673 5.89453V7.0612M7.00065 25.7279H21.0007C23.578 25.7279 25.6673 23.6385 25.6673 21.0612V11.7279C25.6673 9.15054 23.578 7.0612 21.0007 7.0612H7.00065C4.42332 7.0612 2.33398 9.15054 2.33398 11.7279V21.0612C2.33398 23.6385 4.42332 25.7279 7.00065 25.7279Z",
    stroke: "#A461D8",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClinicIcon);
export default __webpack_public_path__ + "static/media/clinic-icon.745319b32b0389c43b1cb4d55a66e682.svg";
export { ForwardRef as ReactComponent };